import { Card, DatePicker } from '@alifd/next';
import { Cascader, Input, Table, Tabs } from 'antd'; // dialog UI
import moment from 'moment';
import React, { useEffect, useState } from 'react';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const { RangePicker } = DatePicker;
const PublicAppointmentHomepage = () => {
  const residentAccountNumbers = client.service('residentAccountNumbers');

  const publicAppointmentHour = client.service('publicAppointmentHour');
  const publicAppointmentCount = client.service('publicAppointmentCount');

  const [publicAppointmentHourArr, setPublicAppointmentHourArr] = useState([]);
  const [publicAppointmentCountArr, setPublicAppointmentCountArr] = useState(
    []
  );
  const [cascadeArr, setCascadeArr] = useState([]);
  const [residentsData, setResidentsData] = useState([]);
  const [filterName, setFilterName] = useState('');
  const [filterHouseholdNumber, setFilterHouseholdNumber] = useState('');
  const [filterDate, setFilterDate] = useState([]);

  useEffect(() => {
    (async () => {
      const publicAppointmentHourData = await publicAppointmentHour.find({});

      const filter = publicAppointmentHourData.data.filter(
        (item) =>
          item.status === '已離場' ||
          item.status === '已取消' ||
          item.status === '未入場'
      );
      setPublicAppointmentHourArr(filter);

      const publicAppointmentCountData = await publicAppointmentCount.find({});
      const filterCount = publicAppointmentCountData.data.filter(
        (item) =>
          item.status === '已離場' ||
          item.status === '已取消' ||
          item.status === '未入場'
      );
      setPublicAppointmentCountArr(filterCount);

      const result = await residentAccountNumbers.find({ query: {} });
      const newData = result.data.map((data) => {
        const newHouseholdNumber = data.householdNumber.split('-');
        return { ...data, householdNumber: newHouseholdNumber };
      });

      setResidentsData(newData);
    })();
  }, [publicAppointmentHour, publicAppointmentCount, residentAccountNumbers]);

  useEffect(() => {
    const objectData = [];
    // layer1
    residentsData.forEach((data) => {
      const number = data.householdNumber;
      if (!objectData.find((item) => item.value === number[0])) {
        objectData.push({ value: number[0], label: number[0], children: [] });
      }
    });
    // layer2
    residentsData.forEach((data) => {
      const number = data.householdNumber;
      if (number[1] !== undefined) {
        if (
          !objectData
            .find((item) => item.value === number[0])
            .children.find((item) => item.value === number[1])
        ) {
          objectData
            .find((item) => item.value === number[0])
            .children.push({
              value: number[1],
              label: number[1],
              children: [],
            });
        }
      }
    });
    // layer3
    residentsData.forEach((data) => {
      const number = data.householdNumber;
      if (number[2] !== undefined && number[1] !== undefined) {
        if (
          !objectData
            .find((item) => item.value === number[0])
            .children.find((item) => item.value === number[1])
            .children.find((item) => item.value === number[2])
        ) {
          objectData
            .find((item) => item.value === number[0])
            .children.find((item) => item.value === number[1])
            .children.push({ value: number[2], label: number[2] });
        }
      }
    });
    setCascadeArr(objectData);
  }, [residentsData]);

  const HourColumns = [
    {
      title: '預約日期',
      dataIndex: 'publicAppointmentDate',
      render: (_value, record) =>
        `${moment(record.publicAppointmentDate).format('YYYY/MM/DD')}`,
    },
    {
      title: '預約時間',
      dataIndex: 'publicAppointmentDate',
      render: (_value, record) =>
        `${
          record.publicUseTime
            ? `${moment(record.publicAppointmentDate).format('HH:mm')}~${moment(
                record.publicAppointmentDate
              )
                .add(record.publicUseTime, 'h')
                .format('HH:mm')}`
            : `${
                record.useTime[0][0] < 10
                  ? `0${record.useTime[0][0]}`
                  : record.useTime[0][0]
              }:00~${record.useTime[0][1]}:00`
        }`,
    },
    {
      title: '公設名稱',
      dataIndex: 'publicName',
    },
    {
      title: '戶號',
      dataIndex: 'householdNumber',
    },
    {
      title: '用戶名',
      dataIndex: 'userName',
    },
    {
      title: '預約人數',
      dataIndex: 'publicAppointmentNumber',
    },

    {
      title: '狀態',
      dataIndex: 'status',
    },
  ];

  const escapeText = (string) => {
    return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  };

  const filterDataBetweenDate = (data) => {
    const filteredData = data.filter((item) => {
      const reservationDate = moment(item.publicAppointmentDate).valueOf();
      const startDate = moment(filterDate[0]).valueOf();
      const endDate = moment(filterDate[1]).valueOf();
      const isBetween =
        startDate <= reservationDate && reservationDate <= endDate;

      return isBetween;
    });

    return filteredData;
  };

  const getTableDataForDisplay = (databaseDataArr) => {
    let data = databaseDataArr;

    if (filterName) {
      data = data.filter((item) => {
        const escapedText = escapeText(filterName);
        const isMatch = item.publicName.match(escapedText);
        return isMatch !== null;
      });
    }
    if (filterHouseholdNumber) {
      data = data.filter((item) => {
        return item.householdNumber === filterHouseholdNumber;
      });
    }

    if (
      filterDate.length > 0 &&
      filterDate[0] !== null &&
      filterDate[1] !== null
    ) {
      data = filterDataBetweenDate(data);
    }

    return data;
  };

  const publicAppointmentHourForDisplay = getTableDataForDisplay(
    publicAppointmentHourArr
  );

  const publicAppointmentCountForDisplay = getTableDataForDisplay(
    publicAppointmentCountArr
  );

  return (
    <>
      <div style={{ display: 'flex' }}>
        <div>
          戶號:
          <Cascader
            className={styles.buttonAdd}
            options={cascadeArr}
            expandTrigger="hover"
            placeholder="戶號查詢"
            onChange={(value) =>
              setFilterHouseholdNumber(value ? value.join('-') : '')
            }
          />
        </div>
        <div style={{ marginLeft: 10 }}>
          預約日期： <RangePicker onChange={(value) => setFilterDate(value)} />
        </div>
        <div style={{ marginLeft: 10 }}>
          公設名稱:
          <Input
            style={{ width: '200px', marginRight: 10 }}
            placeholder="公設名稱查詢"
            onChange={(e) => setFilterName(e.target.value)}
            allowClear
          />
        </div>
      </div>
      <div>
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="全部" key="1">
            <Card free>
              <Card.Content>
                <Table
                  dataSource={[
                    ...publicAppointmentHourForDisplay,
                    ...publicAppointmentCountForDisplay,
                  ]}
                  columns={HourColumns}
                  bordered
                  pagination={{
                    showTotal: () =>
                      `Total: ${
                        publicAppointmentHourForDisplay.length +
                        publicAppointmentCountForDisplay.length
                      }`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                  }}
                />
              </Card.Content>
            </Card>
          </Tabs.TabPane>
          <Tabs.TabPane tab="時段預約" key="2">
            <Card free>
              <Card.Content>
                <Table
                  dataSource={publicAppointmentHourForDisplay}
                  columns={HourColumns}
                  bordered
                  pagination={{
                    showTotal: () =>
                      `Total: ${publicAppointmentHourForDisplay.length}`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                  }}
                />
              </Card.Content>
            </Card>
          </Tabs.TabPane>
          <Tabs.TabPane tab="計次預約" key="3">
            <Card free>
              <Card.Content>
                <Table
                  dataSource={publicAppointmentCountForDisplay}
                  columns={HourColumns}
                  bordered
                  pagination={{
                    showTotal: () =>
                      `Total: ${publicAppointmentCountForDisplay.length}`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                  }}
                />
              </Card.Content>
            </Card>
          </Tabs.TabPane>
        </Tabs>
      </div>
    </>
  );
};

export default PublicAppointmentHomepage;
